export default {
  getPaymentMethodSummaryServiceProvider(state) {
    return () => state.paymentMethodSummary;
  },

  getTariffServiceProvider(state) {
    return () => state.tariffs;
  },
};
